module.exports = __webpack_public_path__ + "media/application/images/research-analyst-bg-786ec98db66be84a61313e4ba110e43d.webp";